// extracted by mini-css-extract-plugin
export default {"buttonClose":"ButtonClose_buttonClose__wgjfl"};